var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarChatBelowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35147 8.75147C6.8201 8.28284 7.5799 8.28284 8.04853 8.75147L12 12.7029L15.9515 8.75147C16.4201 8.28284 17.1799 8.28284 17.6485 8.75147C18.1172 9.22009 18.1172 9.97989 17.6485 10.4485L12.8485 15.2485C12.3799 15.7172 11.6201 15.7172 11.1515 15.2485L6.35147 10.4485C5.88284 9.97989 5.88284 9.22009 6.35147 8.75147Z",
    fill: "#51307F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarChatBelowIcon);
export default __webpack_public_path__ + "static/media/avatar_chat_below_icon.fefb57dd438aa4f36c0a499a98780bdb.svg";
export { ForwardRef as ReactComponent };